import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Project from '../components/Project';
import getProjects from '../utils/getProjects';

class IndexPage extends Component {
  state = {
    project: null,
  };

  componentWillMount() {
    const { data } = this.props;

    const projects = getProjects(data.allContentfulProject.edges);
    const randomProject = projects[Math.floor(Math.random() * projects.length)];

    this.setState({ project: randomProject });
  }

  render() {
    const { data, history } = this.props;
    const { project } = this.state;

    const projectData = {
      allContentfulProject: data.allContentfulProject,
      contentfulProject: project,
    };

    return (
      <Project data={projectData} history={history} />
    );
  }
}

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export const query = graphql`
  query IndexQuery {
    allContentfulProject(sort: { fields: [date] }) {
      edges {
        node {
          slug
          status
          title
          client
          buyLink
          poem {
            __typename
            ... on ContentfulStanza {
              alignment
              text {
                childMarkdownRemark {
                  html
                  htmlAst
                }
              }
            }
          }
          images {
            __typename
            ... on ContentfulProjectImage {
              title
              fullscreen
              asset {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx